/**
 * Google Maps Configuration
 * Centralized configuration for Google Maps API
 * 
 * IMPORTANT: Map ID is required for Advanced Markers
 * - DEMO_MAP_ID: Use for development/testing
 * - For production: Create a Map ID in Google Cloud Console > Maps > Map management
 */

export const GOOGLE_MAPS_CONFIG = {
  // Fallback API key for production when environment variable is not available
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 
          (process.env.NODE_ENV === 'production' ? 'AIzaSyCjn37xr9QBEHjRtJub3ZsRQSzdJOMyYM0' : ''),
  libraries: ['places', 'marker'],
  version: 'weekly',
  region: 'IN', // India
  language: 'en',
  mapId: 'DEMO_MAP_ID', // Required for Advanced Markers
  mapDefaults: {
    center: {
      lat: 28.8955, // Default to Dhanaura area
      lng: 78.2659
    },
    zoom: 14,
    mapTypeId: 'roadmap',
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: false
  },
  searchDefaults: {
    types: ['establishment', 'geocode'],
    componentRestrictions: { country: 'IN' },
    radius: 50000 // 50km radius
  }
};

export const DELIVERY_CONFIG = {
  trackingInterval: 30000, // 30 seconds
  geofenceRadius: 100, // 100 meters
  deliveryRadius: 50000, // 50km max delivery radius
  defaultDeliveryTime: 30, // 30 minutes
  locationAccuracy: {
    enableHighAccuracy: true,
    timeout: 10000,
    maximumAge: 300000 // 5 minutes
  }
};

export default GOOGLE_MAPS_CONFIG;
